import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { REMOVE_PHOTO, REMOVE_PHOTO_FAIL, REMOVE_PHOTO_SUCCES } from '../redux/Ads';
import { DELETE } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';

function* removePhotoFlow({ payload: { photoId, adId, }, }) {
  try {
    const endpoint = `${apiRoot}/photos/${photoId}`;
    const params = { ad: { id: adId, }, };
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: DELETE, endpoint, params, });
    yield put(REMOVE_PHOTO_SUCCES(response));
  } catch (error) {
    yield put(REMOVE_PHOTO_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* RemovePhoto() {
  yield takeLatest(REMOVE_PHOTO, removePhotoFlow);
}
